import React from 'react';
import { Award } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-sage text-white relative" data-id="element-84">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay" data-id="element-85"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-86">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white text-sage mb-8 shadow-lg" data-id="element-87">
          <Award className="w-10 h-10" data-id="element-88" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold font-heading mb-6" data-id="element-89">
          The "Radiant Mother" 7-Day Guarantee
        </h2>

        <div className="prose prose-lg prose-invert mx-auto font-body leading-relaxed" data-id="element-90">
          <p data-id="element-91">Try the protocol. Read the ebooks. Start the supplements.</p>
          <p className="text-xl font-medium" data-id="element-92">
            If in 7 days you don't feel your energy shifting and your brain fog
            lifting, send me an email and I'll refund every penny.
          </p>
          <p data-id="element-93">No questions asked. The risk is 100% on me.</p>
        </div>
      </div>
    </section>;
}